import DOMpurify from 'dompurify'

export default {
  install: (app, options) => {
    options = {
      ...options,
      // allow the 'target' attribute for links
      ADD_ATTR: ['target'],
    }
    app.config.globalProperties.$sanitize = (dirty) => {
      return DOMpurify.sanitize(dirty, options)
    }
  },
}
